import React from 'react'
import {Dimmer, Loader} from 'semantic-ui-react'

// EOI Sources section
const Load = (props) => <Dimmer active>
    <Loader size='massive'>{props.text}</Loader>
</Dimmer>

export default Load